"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrackers = exports.defaultCallback = exports.applyFilters = exports.filterRemoveTrailingSlash = exports.filterReplaceNumbers = exports.MATOMO_CLOUD_URL = void 0;
/**
 * Define the replacement character.
 */
var REPLACE_CHAR = 'X';
/**
 * A map of vailable filters to apply on an input.
 */
var AVAILABLE_FILTERS = {
  filterRemoveTrailingSlash: filterRemoveTrailingSlash,
  filterReplaceNumbers: filterReplaceNumbers
};
/**
 * Define the Matomo endpoint.
 */
exports.MATOMO_CLOUD_URL = 'https://keytradebank.matomo.cloud/matomo.php';
/**
 * Replace groups of 5+ numbers with a fixed REPLACE_CHAR.
 * @param input
 */
function filterReplaceNumbers(input) {
  var filteredInput = input;
  var results = input.match(/([0-9]){5,}/g);
  if (results) {
    filteredInput = results.reduce(function (filteredInput, regExMatch) {
      return filteredInput.replace(regExMatch, REPLACE_CHAR.repeat(regExMatch.length));
    }, input);
  }
  return filteredInput;
}
exports.filterReplaceNumbers = filterReplaceNumbers;
/**
 * Remove trailing slashes.
 * @param input
 */
function filterRemoveTrailingSlash(input) {
  var filteredInput = input;
  if (input.length > 1 && input.substr(-1) === '/') {
    filteredInput = input.substr(0, input.length - 1);
  }
  return filteredInput;
}
exports.filterRemoveTrailingSlash = filterRemoveTrailingSlash;
/**
 * Apply the given filters on an input.
 * @param filterNames
 * @param input
 */
var applyFilters = function (filterNames, input) {
  if (filterNames.length === 0) return input;
  return filterNames.reduce(function (filteredInput, filterName) {
    if (Object.keys(AVAILABLE_FILTERS).includes(filterName)) {
      return AVAILABLE_FILTERS[filterName](filteredInput);
    }
    return filteredInput;
  }, input);
};
exports.applyFilters = applyFilters;
/**
 * Inject the Keytrade Matomo snippet on the window.
 * This will load the Matomo JS assets in your web app.
 *
 * *Note: this only works client-side, not server-side!*
 *
 * @example
 * ```typescript
 * // import Keytrade Matomo package
 * import matomo from '@keytrade/matomo'
 *
 * // inside the <head> of your app add this:
 * <script dangerouslySetInnerHTML={{__html: matomo.injectScript()}}/>
 * ```
 */
var injectScript = function (src) {
  if (src === void 0) {
    src = '//www.keytradebank.be/assets/vendors/matomo/matomo.js';
  }
  return "\nvar _paq = window._paq || [];\n(function() {\n  var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];\n  g.type='text/javascript'; g.async=true; g.defer=true; g.src='".concat(src, "'; s.parentNode.insertBefore(g,s);\n})();");
};
/**
 * Define the default behavior
 * @param siteID
 * @param filters
 */
var defaultCallback = function (siteID, filters) {
  var referrer = document.referrer,
    title = document.title;
  var _a = window.location,
    origin = _a.origin,
    pathname = _a.pathname,
    search = _a.search;
  var filteredPathname = (0, exports.applyFilters)(filters, pathname + search);
  var filteredReferrer = (0, exports.applyFilters)(filters, referrer);
  var _b = (0, exports.getTrackers)(siteID),
    primTracker = _b[0],
    secTracker = _b[1];
  // track page view on primary tracker
  // setup page info
  primTracker.setDocumentTitle(title);
  primTracker.setReferrerUrl(filteredReferrer);
  primTracker.setCustomUrl(origin + filteredPathname);
  // activate extra options
  primTracker.trackContentImpressionsWithinNode();
  primTracker.enableLinkTracking();
  primTracker.trackPageView();
  // track page view on secondary tracker
  if (secTracker) {
    // setup page info
    secTracker.setDocumentTitle(title);
    secTracker.setReferrerUrl(filteredReferrer);
    secTracker.setCustomUrl(origin + filteredPathname);
    // activate extra options
    secTracker.trackContentImpressionsWithinNode();
    secTracker.enableLinkTracking();
    secTracker.trackPageView();
  }
  window._paq.push(['FormAnalytics::scanForForms']);
  //NOT IMPLEMENTED YET      window._paq.push(['MediaAnalytics::scanForMedia']);
};
exports.defaultCallback = defaultCallback;
/**
 * Get Matomo trackers.
 *
 * @param {string | number | Array<string> | Array<number>} siteID This is the site identifier (or multiple identifiers) you'll see when generating a new Tracking code in Matomo.
 *
 * @returns Array<tracker>  List of primary and an optional secondary tracker.
 */
var getTrackers = function (siteID) {
  var trackers = [];
  var piwikTracker = window.Piwik.getTracker();
  // manage primary SiteID + optional secondary SiteID
  var primarySiteID = siteID;
  var secondarySiteID;
  if (Array.isArray(siteID) && siteID.length === 2) {
    var prim = siteID[0],
      sec = siteID[1];
    primarySiteID = prim;
    secondarySiteID = sec;
  }
  // setup primary tracker
  piwikTracker.setTrackerUrl(exports.MATOMO_CLOUD_URL);
  piwikTracker.setSiteId(primarySiteID);
  // push primary tracker
  trackers.push(piwikTracker);
  // setup secondary tracker
  if (secondarySiteID) {
    var piwikTracker2 = window.Piwik.getTracker();
    piwikTracker2.setTrackerUrl(exports.MATOMO_CLOUD_URL);
    piwikTracker2.setSiteId(secondarySiteID);
    // push secondary tracker
    trackers.push(piwikTracker2);
  }
  return trackers;
};
exports.getTrackers = getTrackers;
/**
 * Track a page with Matomo.
 *
 * @param {string | number | Array<string> | Array<number>} siteID This is the site identifier (or multiple identifiers) you'll see when generating a new Tracking code in Matomo.
 * @param {FilterNames} filters Array of filters to apply on the URL.
 * @param {Callback} callback Provide a custom callback to be executed instead of the default one.
 *
 * @note To be able to track a page you'll need to have a KEYcookiepolicy cookie set where the 3rd option (statistical/analytical) is set to 1.
 *
 * @example
 * ```typescript
 * // import Keytrade Matomo package
 * import matomo from '@keytrade/matomo'
 *
 * // execute this fn in your app's routing handler where
 * // MATOMO_ANALYTICS_SITEID is coming from your app config
 * matomo.trackPage(MATOMO_ANALYTICS_SITEID)
 * ```
 * @example
 * ```typescript
 * // import Keytrade Matomo package
 * import matomo from '@keytrade/matomo'
 *
 * // execute this fn in your app's routing handler where
 * // MATOMO_ANALYTICS_SITEID is coming from your app config
 * matomo.trackPage([MATOMO_ANALYTICS_PRIMARY_SITEID, MATOMO_ANALYTICS_SECONDARY_SITEID])
 * ```
 * @example
 * ```typescript
 * // if you want to disable the default filters you can reduce the array
 * matomo.trackPage(MATOMO_ANALYTICS_SITEID, ['filterRemoveTrailingSlash'])
 * // or remove all:
 * matomo.trackPage(MATOMO_ANALYTICS_SITEID, [])
 * ```
 * @example
 * ```typescript
 * // you can also choose to write your own callback
 * // but you need to talk to the Piwik lib yourself!
 * const callback = () => { console.log('running my own callback') }
 * matomo.trackPage(MATOMO_ANALYTICS_SITEID, ['filterRemoveTrailingSlash'], callback)
 * ```
 */
var trackPage = function (siteID, filters, callback) {
  if (filters === void 0) {
    filters = ['filterRemoveTrailingSlash', 'filterReplaceNumbers'];
  }
  if (callback === void 0) {
    callback = exports.defaultCallback;
  }
  if (window && window._paq && window.Piwik) {
    if (typeof callback === 'function') {
      setTimeout(function () {
        callback(siteID, filters);
      }, 750);
    }
  }
};
/**
 * Track an event with Matomo.
 *
 * @param {string | number | Array<string> | Array<number>} siteID This is the site identifier (or multiple identifiers) you'll see when generating a new Tracking code in Matomo.
 * @param {string} category Category set for this event
 * @param {string} action Action set for this event
 * @param {string} name Optional name set for this event (should be name OR value)
 * @param {string} value Optional value set for this event (should be name OR value)
 * @param {Callback} callback Optional callback set for this event to be called after matomo call has been fulfilled
 *
 * @note To be able to track a page you'll need to have a KEYcookiepolicy cookie set where the 3rd option (statistical/analytical) is set to 1.
 */
var trackEvent = function (siteID, category, action, name, value, callback) {
  if (window && window._paq && window.Piwik) {
    // we will silently fail
    // the project calling this function should
    if (!category || !action) return;
    var _a = (0, exports.getTrackers)(siteID),
      primTracker = _a[0],
      secTracker = _a[1];
    // if we have a secondary tracker we don't want to execute the primary callback
    var primCallback = secTracker ? undefined : callback;
    primTracker.trackEvent(category, action, name, value, undefined, primCallback);
    if (secTracker) {
      secTracker.trackEvent(category, action, name, value, undefined, callback);
    }
  }
};
exports.default = {
  injectScript: injectScript,
  trackEvent: trackEvent,
  trackPage: trackPage
};